import React from "react";
import { Form, Button, Alert } from "react-bootstrap";
import axios from "axios";
import Loader from "../../components/Loader";
import OfferMap from "../../components/OfferMap";

const AccessoriesForm = ({
  productData,
  setProductData,
  handleInputChange,
  handleFormattedChange,
  uploading,
  setUploading,
  userInfo,
  accessoryType,
  setAccessoryType,
  onSubmit,
}) => {
  const { name, price, image, brand, countInStock, description, offersIds } =
    productData;

  const uploadFileHandler = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("image", file);
    setUploading(true);

    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.post("/api/upload", formData, config);
      setProductData({
        ...productData,
        image: data,
      });
      setUploading(false);
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };

  const getAccessoryTypeTitle = () => {
    switch (accessoryType) {
      case "Solution":
        return "Solution";
      case "LensCase":
        return "Lens Case";
      case "LensCleaner":
        return "Lens Cleaner";
      case "ClipOns":
        return "Clip-Ons";
      default:
        return "Accessory";
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      {!accessoryType && (
        <Alert variant='warning'>
          Please select an accessory type from the drawer first.
        </Alert>
      )}

      <Form.Group controlId='accessoryType' className='mb-3'>
        <Form.Label>Accessory Type</Form.Label>
        <Form.Control
          as='select'
          value={accessoryType}
          onChange={(e) => setAccessoryType(e.target.value)}
          required
        >
          <option value='' disabled>
            Select Type
          </option>
          <option value='Solution'>Solution</option>
          <option value='LensCase'>Lens Case</option>
          <option value='LensCleaner'>Lens Cleaner</option>
          <option value='ClipOns'>Clip-Ons</option>
        </Form.Control>
      </Form.Group>

      <Form.Group controlId='name' className='mb-3'>
        <Form.Label>{getAccessoryTypeTitle()} Name</Form.Label>
        <Form.Control
          required
          type='text'
          placeholder='Enter name'
          value={name}
          onChange={handleInputChange}
        />
      </Form.Group>

      <Form.Group controlId='price' className='mb-3'>
        <Form.Label>{getAccessoryTypeTitle()} Price</Form.Label>
        <Form.Control
          required
          type='number'
          placeholder='Enter price'
          value={price}
          onChange={handleInputChange}
        />
      </Form.Group>

      <Form.Group controlId='image' className='mb-3'>
        <Form.Label>{getAccessoryTypeTitle()} Image</Form.Label>
        <Form.Control
          type='text'
          required
          placeholder='Enter image url'
          value={image}
          disabled={image !== ""}
          onChange={handleInputChange}
        />
        <Form.Control
          type='file'
          id='image-file'
          label='Choose File'
          accept='.jpg, .jpeg, .png'
          onChange={uploadFileHandler}
          className='mt-2'
        />
        {uploading && <Loader />}
      </Form.Group>

      <Form.Group controlId='brand' className='mb-3'>
        <Form.Label>{getAccessoryTypeTitle()} Brand</Form.Label>
        <Form.Control
          required
          type='text'
          placeholder='Enter brand'
          value={brand}
          onChange={handleFormattedChange}
        />
      </Form.Group>
      <Form.Group controlId='ProductPriority' className='mb-3'>
        <Form.Label>ProductPriority</Form.Label>
        <Form.Select
          onChange={handleInputChange}
          required
          onInvalid={(e) => {
            e.target.setCustomValidity("Please Choose this");
          }}
          onInput={(e) => {
            e.target.setCustomValidity("");
          }}
        >
          <option value='' hidden>
            Select
          </option>
          <option value='2'>2</option>
        </Form.Select>
      </Form.Group>

      <Form.Group controlId='countInStock' className='mb-3'>
        <Form.Label>Count In Stock</Form.Label>
        <Form.Control
          required
          type='number'
          placeholder='Enter count in stock'
          value={countInStock}
          onChange={handleInputChange}
        />
      </Form.Group>

      {accessoryType === "Solution" ? (
        <Form.Group controlId='solutionQuantity'>
          <Form.Label>Select Solution Quantity</Form.Label>
          <Form.Select
            onChange={handleInputChange}
            required
            onInvalid={(e) => {
              e.target.setCustomValidity("Please Choose this");
            }}
            onInput={(e) => {
              e.target.setCustomValidity("");
            }}
          >
            <option value='' hidden>
              Select
            </option>
            <option value='60'>60 ml</option>
            <option value='120'>120 ml</option>
            <option value='355'>355 ml</option>
            <option value='500'>500 ml</option>
          </Form.Select>
        </Form.Group>
      ) : null}

      <Form.Group controlId='description' className='mb-3'>
        <Form.Label>Description</Form.Label>
        <Form.Control
          required
          as='textarea'
          rows={3}
          placeholder='Enter description'
          value={description}
          onChange={handleInputChange}
        />
      </Form.Group>

      <Form.Group className='mb-3'>
        <Form.Label>Map with Offers</Form.Label>
        <OfferMap
          offersIds={offersIds}
          setOffersIds={(ids) =>
            setProductData({ ...productData, offersIds: ids })
          }
        />
      </Form.Group>

      <Button
        type='submit'
        variant='primary'
        className='mt-3'
        disabled={!accessoryType}
      >
        Add {getAccessoryTypeTitle()}
      </Button>
    </Form>
  );
};

export default AccessoriesForm;
